
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 500 300"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-1v1h.5","transform":"rotate(18 0 -1)","fill":"#fcd116"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})])]),_c('path',{attrs:{"fill":"#ce1126","d":"M0 0h500v300H0z"}}),_c('path',{attrs:{"fill":"#007a5e","d":"M42 42h416v216H42z"}}),_c('path',{attrs:{"d":"M42 42h416L42 258h416z","fill":"#fcd116"}}),_c('circle',{attrs:{"cx":"250","cy":"150","r":"36","fill":"#ce1126"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"matrix(33 0 0 33 250 150)"}}),_c('use',{attrs:{"xlink:href":"#d","x":"-100"}}),_c('use',{attrs:{"id":"d","xlink:href":"#c","transform":"matrix(19.5 0 0 19.5 250 21)"}}),_c('use',{attrs:{"xlink:href":"#d","x":"100"}}),_c('use',{attrs:{"xlink:href":"#d","x":"-100","y":"258"}}),_c('use',{attrs:{"xlink:href":"#d","y":"258"}}),_c('use',{attrs:{"xlink:href":"#d","x":"100","y":"258"}}),_c('path',{attrs:{"d":"M67.749 150.41c4.504 8.39 13.265 17.52 20.916 20.73.123-8.52-2.9-19.44-7.034-28.14l-13.882 7.41z","fill":"#ce1126"}}),_c('path',{attrs:{"d":"M60.112 121.63c6.529 13.61-16.933 46.08 22.156 53.69-4.822-6.58-7.931-17.44-6.755-26.16 8.201 3.12 16.83 12.25 20.317 19.23 10.23-37.15-26.24-34.89-35.718-46.76z","fill":"#fcd116"}})])
          )
        }
      }
    